export class DirectusError extends Error {
  constructor(error, response) {
    super(error.message);
    this.name = "DirectusError";
    this.code = error.extensions?.code || "UNKNOWN_ERROR";
    this.status = getStatusFromCode(this.code);
    this.extensions = error.extensions;
    this.response = response; // ✅ attach full response here
  }
}

function getStatusFromCode(code) {
  switch (code) {
    case "FORBIDDEN":
      return 403;
    case "INVALID_CREDENTIALS":
      return 401;
    case "INVALID_TOKEN":
      return 401;
    case "INVALID_PAYLOAD":
      return 400;
    case "INTERNAL_SERVER_ERROR":
      return 500;
    case "SERVICE_UNAVAILABLE":
      return 503;
    case "RECORD_NOT_FOUND":
      return 404;
    default:
      return 500;
  }
}

export function handleDirectusResponse(response) {
  if (response?.errors?.length > 0) {
    const error = response.errors[0];
    throw new DirectusError(error, response);
  }
  return response;
}
